import HTTP from './http-interceptor';
import { DASHBOARD, ACHIEVEMENTS } from '../constants';

const AchievementsService = {
    getChartData: (area, team, player, campaign = '') => {
        return HTTP.get(`${DASHBOARD.ESTADISTICAS_PREGUNTAS}${area}/${team}/${player}/${campaign}`);
    },
    getEfficacy: (area, team, player, campaign = '') => {
        return HTTP.get(`${DASHBOARD.ESTADISTICAS_EFECTIVIDAD}${area}/${team}/${player}/${campaign}`);
    },
    getHighlights: (area, team, player, campaign = '') => {
        return HTTP.get(`${DASHBOARD.ESTADISTICAS_CATEGORIAS}${area}/${team}/${player}/${campaign}`);
    },
    getTeamAchievements: (area, team, player) => {
        return HTTP.get(`${DASHBOARD.ESTADISTICAS_COPAS}${area}/${team}/${player}`);
    },
    getMorePlayed: (area, player, campaign = '') => {
        return HTTP.get(`${DASHBOARD.MAS_RETOS_JUGADOS}${area}/${player}/${campaign}`);
    },
    getMoreWon: (area, player, campaign = '') => {
        return HTTP.get(`${DASHBOARD.MAS_RETOS_GANADOS}${area}/${player}/${campaign}`);
    },
    getMoreLost: (area, player, campaign = '') => {
        return HTTP.get(`${DASHBOARD.MAS_RETOS_PERDIDOS}${area}/${player}/${campaign}`);
    },
    getBadges: (area, team, player) => {
        return HTTP.get(`${ACHIEVEMENTS.LISTA}${area}/${team}/${player}`);
    },
    getCategories: (area, player) => {
        return HTTP.get(`${DASHBOARD.CATEGORIAS}${area}/${player}`);
    },
    getVS: (area, player, opponent) => {
        return HTTP.get(`${DASHBOARD.VS}${area}/${player}/${opponent}`);
    },
}

export default AchievementsService;